import { Modal } from '@mantine/core';
import SecondaryButton from 'components/secondaryButton';
import ReactPlayer from 'react-player';

const PreviewVideo = ({ previewVideo, setPreviewVideo, file }) => {
  return (
    <div>
      <Modal
        opened={previewVideo}
        onClose={() => {
          setPreviewVideo(false);
        }}
        overlayColor={'#F8F7F799'}
        overlayBlur={20}
        overlayOpacity={0.5}
        centered
        size={'80%'}
        radius='md'
        overflow='inside'
        transitionDuration={100}
        classNames={{
          title: 'w-full font-bold  text-lg py-4  text-center text-primary',
          modal: 'pl-10 h-[80vh]',
          body: 'scroller -mr-4 pr-8 h-[70vh]',
        }}
      >
        <div className='h-full'>
          <div className='flex justify-center flex-col items-center w-full'>
            <ReactPlayer url={file} playing={true} controls={true} />
          </div>
          <div className='flex justify-center items-center mt-1'>
            <button
              onClick={() => setPreviewVideo(false)}
              className='cursor-pointer'
            >
              <SecondaryButton>Cancel</SecondaryButton>
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PreviewVideo;
